var React = require('react');

function ArrowSimpleDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.25 7.311L12.53 18.03C12.3895 18.1707 12.1988 18.2498 12 18.2498C11.8012 18.2498 11.6105 18.1707 11.47 18.03L0.75 7.311","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowSimpleDownInline.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowSimpleDownInline;

ArrowSimpleDownInline.default = ArrowSimpleDownInline;
